import { createThunk } from '@app/store/thunk'

export function getActiveChannelsSet() {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().getOrInsert(ActiveChannelsSetSymbol, () => new Set<string>()))
}
export function setActiveChannelsSet(value: Set<string>) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ActiveChannelsSetSymbol, value))
}

const ActiveChannelsSetSymbol = Symbol('ActiveChannelsSet')
